
export const adminRoutes = [
    {
        path: '/siteadmin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/dashboard'));
            reject(error);
        }),
    },
    {
        path: '/inputform',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./site-admin/inputform'));
          reject(error);
        }),
      },
      {
        path: '/table',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./site-admin/table'));
          reject(error);
        }),
      },
    {
        path: '/siteadmin/users', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/users'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/partners',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/partners'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/category'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/sub-category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/subCategory'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/booking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/category/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addCategory'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/sub-category/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addSubCategory'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/:from/view/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/viewBooking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/users/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editUser'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/partners/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editPartner'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/category/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editCategory'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/sub-category/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editSubCategory'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/promo-code/list',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/promoCodeList'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/promo-code/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/addPromoCode'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/promo-code/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/promoCode/editPromoCode'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/completed-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/completedBooking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancelled-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/cancelledBooking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/currency',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/currency'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/site', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/siteSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/change/admin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/changeAdmin'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/notifications',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageNotifications'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancel-reasons',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageCancelReasons'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/ratings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/ratings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancel-reasons/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addCancelReason'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancel-reasons/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editCancelReason'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/add-location',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addLocation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/location',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageLocationList'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/edit-location/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editLocation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/banner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/homeSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/categorySettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/category',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/citySettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/user',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/safetySettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/partner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/signupSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/footer',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/footerSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/autoPayout'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/failed-payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/failedPayout'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/staticpage/manage',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/staticPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/contentpage/manage', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/contentPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/contentpage/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addContentPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/contentpage/edit/:pageId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editContentPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/staticpage/edit/:pageId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editStaticPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/pricing/list',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/pricingList'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/pricing/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/addPricing'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/pricing/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/pricing/editPricing'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/admin-roles',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/adminRoles'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/admin-users',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/adminUser'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/precaution-notification', // Completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/precautionNotification/updatePrecautionNotification'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/:from/chat-message/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/chatMessage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/mobile-app', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/mobileSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/tracking',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/tracking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/sms-methods',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/smsMethod'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/sms-method/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/smsMethod/editSmsMethod'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/schedule-jobs',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/scheduleBooking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/config', // completed
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/configSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/payment-gateway',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/paymenGateway'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addTopFeature'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/partners/category/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageCategory'));
            reject(error)
        }),
    },
    {
        path: '/siteadmin/partners/sub-category/:id/:categoryid',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manageSubCategory'));
            reject(error)
        }),
    },
    {
        path: '/siteadmin/homepage/top-feature/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/editTopFeature'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/manual-bookings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/manualBooking'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/manual-bookings/create',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./site-admin/addManualBooking'));
            reject(error);
        }),
    },
];